import { render, staticRenderFns } from "./tokenMg.vue?vue&type=template&id=3e3224ec&scoped=true&"
import script from "./tokenMg.vue?vue&type=script&lang=js&"
export * from "./tokenMg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3224ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e3224ec')) {
      api.createRecord('3e3224ec', component.options)
    } else {
      api.reload('3e3224ec', component.options)
    }
    module.hot.accept("./tokenMg.vue?vue&type=template&id=3e3224ec&scoped=true&", function () {
      api.rerender('3e3224ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/facebook/tokenMg.vue"
export default component.exports